export default __webpack_public_path__ + "static/media/fb.9c72aa96.png";